import { Component, OnInit, Input } from '@angular/core';
import { PopoverController, NavController } from '@ionic/angular';
import { InvoiceService } from '../../invoices/invoice.service';
import { DialogService } from '../../_services';
import { first, last } from 'rxjs/operators';
import { StringConstants } from '../../_constants/stringConstants';
import { ChequeDetailComponent } from '../cheque-detail/cheque-detail.component';
import { AppInfoService } from '../../_services/appInfoService';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'invoice-reject-reason',
  templateUrl: './invoice-reject-reason.component.html',
})
export class InvoiceRejectReasonComponent implements OnInit {

  // private selectRejectionReason: string = this.translate.instant('LABELS.SELECT_REJECTION_REASON');
    @Input() payData: any = {};
    rejectReasons;
    selectedReason;
    disputedInvoiceList;
    cpgName;
    loading = false;
    chequeInfo = false;
    disputInvFlag = false;
  constructor(
      private invoiceService: InvoiceService,
      private dialogService: DialogService,
      private modal: PopoverController,
      private navCtrl: NavController,
      private appInfoService: AppInfoService,
      private translate: TranslateService
  ) { }

  ngOnInit() {
  }


  close() {
    this.modal.dismiss();
  }

  submitReason(rejectOption) {
    if (!rejectOption || !rejectOption.disc) {
      this.dialogService.showMessageDialog(this.translate.instant('LABELS.SELECT_REJECTION_REASON'));
      return;
    }
    this.disputInvFlag = false;
    //to fill cheque details (info) only for  SellerA
    if (rejectOption.disc == "Already Paid by Check" && this.chequeInfo) {
      //open cheque information popup
      this.getChequeInfoPage(rejectOption)
    }else if (rejectOption.disc == "Disputed Invoice" && this.payData.paySettings.DISPUTE_INVOICE_REASON_FLAG) {
      this.doDisputedInvoiceCall(rejectOption);
      this.disputInvFlag = true;
    } else {
        const ccDetails = { "val": rejectOption.val, "disc": { "RO": rejectOption.val, "CC": rejectOption.disc, 'DID': ''} }
        //submit invoice reject reason call
        this.sendInvoiceForReject(ccDetails);
    }
    /*
      {"RO":11,"CC":{"CHN":855757575885,"CHA":"855858","CHD":"230819","CHB":"Dttxfxf"}},
    */
  }

  doDisputedInvoiceCall(reason) {
    reason.invoice = this.payData.invoice;
    this.setAppBusy();
    this.invoiceService.getDisputedInvoiceReasons(reason).pipe(first()).subscribe(data => {
    this.setAppIdle();
    this.disputedInvoiceList = data.data;
    }, () => {
      this.setAppIdle();
    });
  }

  submitDisputedInv(rejectOption) {
    if (!rejectOption || !rejectOption.description) {
      this.dialogService.showMessageDialog(this.translate.instant('LABELS.SELECT_REJECTION_REASON'));
      return;
    }
    const ccDetails = { "val": 3, "disc": { "RO": 3, "DID": rejectOption.description } } //disputed invoice description
    this.sendInvoiceForReject(ccDetails);
  }

  sendInvoiceForReject(rejectOption) {
    rejectOption.invoice = this.payData.invoice;
    rejectOption.payModel = this.payData.payModel;
    rejectOption.TI = this.payData.invoiceData.TI;


    const doReject = () => {
      this.invoiceService.submitRejectInvoice(rejectOption, this.payData).pipe(first()).subscribe(data => {
        this.setAppIdle();
        if (!data.data.EC) {
            this.navCtrl.navigateBack(['/invoices']);
        }
        this.dialogService.showMessageDialog(data.msg);
        this.close();
      }, () => {
        this.setAppIdle();
      });
    };

    this.setAppBusy();
    this.appInfoService.checkUpdateRequired().then((updateData: any) => {
      if (updateData && updateData.update && updateData.packageName) {
        this.setAppIdle();
        this.appInfoService.processAppUpdate(updateData);
      } else {
        doReject();
      }
    }).catch(error => {
      doReject();
    });
  }

  async getChequeInfoPage(rejectOption) {

      const modal = await this.modal.create({
        component: ChequeDetailComponent,
        componentProps: {
          payData: this.payData
        },
        cssClass:['invChequeDetailContainer']
      });
      modal.onDidDismiss()
        .then((result) => {
          if (result['data']) {
            rejectOption = result['data'];
            this.sendInvoiceForReject(rejectOption)
            this.close();
          }
        });
      return await modal.present();



  }

  setAppBusy() {
    this.loading = true;
    this.dialogService.showWaitMessage(this.translate.instant('MESSAGES.PLEASE_WAIT'));
  }
  setAppIdle() {
    this.loading = false;
    this.dialogService.hideWaitMessage();
  }

}
